export default __webpack_public_path__ + "static/media/(72).5d07577f.jpg";